import DMSArchive from "./DMSArchive";
import AdminLayout from "./AdminLayout";
import Announcements from "./Announcements";
import MOTD from "./MOTD";
import DownloadUsersPage from "./DownloadUsers";
import OperatorUsers from "./OperatorUsers";
import IncidentEntry from "./IncidentEntry";
import RoutesUsers from "./RoutesUsers";

const module = {
  routeProps: {
    path: "Admin",
    component: AdminLayout,
  },

  name: "Admin",
  label: "Admin",
  submodules: [
    DMSArchive,
    Announcements,
    MOTD,
    DownloadUsersPage,
    OperatorUsers,
    RoutesUsers,
    IncidentEntry,
  ],
  showOnHeader: true,
};

export default module;
